module.exports = __webpack_public_path__ + "b96bc416da89858f817ec427e9ce731f.svg";